import { ClientType } from './clientSearchTypes'

export enum NotificationEnum {
    FETCHING_NOTIFICATION = 'fetching notification',
    FETCH_NOTIFICATION_SUCCESS = 'fetch notification success',
    FETCH_NOTIFICATION_FAILURE = 'fetch notification failure',
    MARK_NOTIFICATION_READ = 'mark notification read',
    HAS_UNREAD_NOTIFICATIONS = 'has unread notifications'
}

export type NotificationType = {
    id: number
    uuid?: string
    user_id: string
    delivery_date: string
    type: string
    sub_type: string
    message_en: string
    message_fr: string
    read_status: boolean
    created_date: string
    updated_at: string
    send_sms: boolean
    send_push: boolean
    client_list: Partial<ClientType>[]
}
export type NotificationPayloadType = {
    notificationList: NotificationType[] | []
    loading?: boolean
    error?: string
    hasUnreadNotifications?: boolean
}

type FetchingNotificationType = {
    type: NotificationEnum.FETCHING_NOTIFICATION
}

type FetchNotificationSuccess = {
    type: NotificationEnum.FETCH_NOTIFICATION_SUCCESS
    payload: NotificationPayloadType
}

type FetchNotificationFailure = {
    type: NotificationEnum.FETCH_NOTIFICATION_FAILURE
    payload: string
}

type MarkNotificationRead = {
    type: NotificationEnum.MARK_NOTIFICATION_READ
    payload: NotificationType[]
}

type HasUnreadNotifications = {
    type: NotificationEnum.HAS_UNREAD_NOTIFICATIONS
    payload: boolean
}

export type NotificationActionType =
    | FetchingNotificationType
    | FetchNotificationSuccess
    | FetchNotificationFailure
    | MarkNotificationRead
    | HasUnreadNotifications
